import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Box, Grid } from '@material-ui/core';
import _ from 'lodash';

export default function BranchBox({ branch, isCurrent, isRTL }: any) {
  const docscount = branch?.docscount ? JSON.parse(branch?.docscount) : [];
  const items = _.sortBy(docscount, '_id');
  return (
    <Card
      elevation={3}
      style={{
        minHeight: 300,
        borderRadius: 15,
      }}
    >
      <Box
        style={{
          backgroundColor: isCurrent ? '#008000' : '#f3f3f3',
          padding: 10,
          borderTopLeftRadius: 15,
          borderTopRightRadius: 15,
        }}
      >
        <Typography
          style={{ color: isCurrent ? '#fff' : undefined, textAlign: 'center' }}
          variant="h4"
        >
          {branch?.name}
        </Typography>
      </Box>
      <CardContent>
        {items && items.length > 0 && (
          <Grid container spacing={2}>
            {items.map((dc: any) => {
              const bgcolr =
                dc._id === 1
                  ? '#2DCCFF22'
                  : dc._id === 6
                  ? '#FED76622'
                  : dc._id === 7
                  ? '#ff666622'
                  : dc._id === 8
                  ? '#80808022'
                  : dc._id === 0
                  ? '#aaaaaa22'
                  : '#61E29422';
              return (
                <Grid item xs={12} md={6}>
                  <Box
                    style={{
                      display: 'flex',
                      backgroundColor: bgcolr,
                      padding: 5,
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Typography>{isRTL ? dc.nameAr : dc.name}</Typography>
                    <Typography style={{ fontWeight: 'bold' }}>
                      {dc.count}
                    </Typography>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        )}
      </CardContent>
    </Card>
  );
}
